import React from 'react';
import Tabs from '@ey/canvascoreservices/TabBar';
import Utility from '../../../util/utilityfunctions';

export default function TabBar(props) {
	const {
		id,
		activeTab,
		badge,
		tabs,
		onTabChange,
		onHover,
		onTabMouseEnter,
		onTabMouseLeave,
		styleName,
		tabColor,
		ellipse,
		allowActiveTabClick,
		onPreClick
	} = props;

	return (
		<Tabs
			allowActiveTabClick={allowActiveTabClick}
			id={id}
			activeTab={activeTab}
			badge={badge}
			tabs={tabs}
			onTabChange={onTabChange}
			onHover={onHover}
			onTabMouseEnter={onTabMouseEnter}
			onTabMouseLeave={onTabMouseLeave}
			styleName={styleName}
			tabColor={tabColor}
			theme={Utility.getTheme()}
			onPreClick={onPreClick}
			ellipse
		/>
	);
}
